import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { EmptyCart } from '../components/EmptyCart.js';
import { goBack } from '../utils/navigation.js';

const EmptyCartContainer = ({ onClick =goBack  })=>{
    const { getLabel  } = useIntl();
    const labels = {
        cartTitle: getLabel('cart.title'),
        emptyCartTitle: getLabel('cart.emptyCart.title'),
        emptyCartMessage: getLabel('cart.emptyCart.message'),
        buttonCaption: getLabel('cart.actions.goBack')
    };
    return /*#__PURE__*/ React.createElement(EmptyCart, {
        labels: labels,
        onClick: onClick
    });
};

export { EmptyCartContainer };
//# sourceMappingURL=EmptyCartContainer.js.map
